import React from 'react';
import Select from "react-select";

import { AiOutlineClose } from "react-icons/ai";

import {
  Modal,
  ModalContent,
  ModalHeading,
  ModalTitle,
  CloseBtn,
  ModalBody,
  Form,
  FormField,
  InputField,
  ButtonWrapper,
  SubmitButton,
} from './styled';

const SignUpModal = ({ closeModal, closeLoginModal }) => {

  const closeModals = ()=> {
    closeModal(false);
    closeLoginModal(false);
  }

  const options = [
    {value: 'store', label: 'Store' },
    {value: 'wholesale', label: 'Wholesale' },
    {value: 'restaurant', label: 'Restaurant' },
    {value: 'pharmacy', label: 'Pharmacy' },
    
  ]

  return (
    <Modal className='modal'>
      <ModalContent>
        <ModalHeading>
          <ModalTitle>Enter Your Business Details</ModalTitle>
          <CloseBtn onClick={closeModals}>
            <AiOutlineClose />
          </CloseBtn>
        </ModalHeading>
        <ModalBody>
          <Form>
            <FormField>
              <InputField type="text" name="bname" id="bname" placeholder="Business Name" required />
            </FormField>
            <FormField>
              <Select 
                name="btype" 
                id="btype" options={options} 
                placeholder="Business Type"
                className='selectField'
              />
            </FormField>
            <FormField>
              <InputField type="text" name="phone" id="phone" placeholder="Phone Number" required />
            </FormField>
            <ButtonWrapper>
              <SubmitButton>Start Trail</SubmitButton>
            </ButtonWrapper>
          </Form>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default SignUpModal;
